import { MutableRefObject, ReactNode, useEffect, useRef, useState } from 'react';

import { clsx } from 'clsx';

import { Portal } from '@shared/ui/Portal';

import cls from './Tooltip.module.scss';

type TooltipProps = {
  label: string;
  className?: string;
  classNameTooltip?: string;
  children: ReactNode;
};

export const Tooltip = ({ children, className, label, classNameTooltip }: TooltipProps) => {
  const wrapRef = useRef() as MutableRefObject<HTMLDivElement>;
  const labelRef = useRef() as MutableRefObject<HTMLDivElement>;

  const [hover, setHover] = useState(false);

  const mouseOnHandler = () => {
    setHover(true);
  };

  const mouseLeaveHandler = () => {
    setHover(false);
  };

  useEffect(() => {
    if (hover) {
      const { x, y, width } = wrapRef.current.getBoundingClientRect();
      const labelWidth = labelRef.current.clientWidth;
      const labelHeight = labelRef.current.clientHeight;
      labelRef.current.style.left = `${x - (labelWidth / 2 - width / 2)}px`;
      labelRef.current.style.top = `${y - (labelHeight + 4)}px`;
    }
  }, [hover, wrapRef, labelRef]);

  return (
    <div
      ref={wrapRef}
      onMouseOver={mouseOnHandler}
      onMouseLeave={mouseLeaveHandler}
      className={clsx(cls.wrap, className)}
    >
      {children}
      {hover && (
        <Portal>
          <div
            ref={labelRef}
            className={clsx(cls.label, classNameTooltip)}
          >
            {label}
          </div>
        </Portal>
      )}
    </div>
  );
};
